import {
  laptopMediumMax,
  tabletMin,
  mobileLargeMax,
  mobileXXLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';
import { Placeholder, Container as PropertyBadge } from '../property-box/PropertyBadge.style';
import { Row3, Row4, Row5 } from './PropertyPlaceholder.style';
import { Prefix } from './PropertyPrice.style';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.background};
  margin: 30px 0;

  @media print {
    display: none;
  }

  ${Prefix} {
    display: none;
  }

  ${Placeholder}, ${PropertyBadge} {
    display: none;
  }
`;

export const LoadingBox = styled.div`
  width: 100%;

  ${Row3}, ${Row4} {
    display: none;
  }
  ${Row5} {
    margin-top: 35px;
  }
`;

export const Title = styled.h2`
  font-size: 21px;
  color: ${(props) => props.theme.textDark};
  margin-bottom: 20px;
`;

export const EmptyText = styled.p`
  color: ${(props) => props.theme.textDark};
  margin-top: 15px;
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;

  @media (${laptopMediumMax}) and (${tabletMin}) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (${mobileLargeMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PropertyContent = styled(Link)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 15px;
  position: relative;

  &:hover {
    text-decoration: underline;
  }

  @media (${mobileXXLargeMax}) {
    flex: 0 0 240px;
  }
`;

export const PropertyImage = styled.img`
  display: block;
  max-width: 100%;
`;

export const PropertyNoImage = styled.img`
  display: block;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundLighter};
`;

export const TextBox = styled.div`
  flex: 1;
  padding: 15px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;

  p {
    color: ${({ theme }) => theme.textDark};
    font-size: 17px;
  }
`;

export const AccountLogo = styled.div`
  width: 38px;
  height: 38px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
